export const yesNoItems = [
    { id: "yes", label: "Yes" },
    { id: "no", label: "No" }
]

export function getPeriods(values, periods) {
    if (values.has(0)) {
        // Flexible
        return periods
    }
    const arrayValues = Array.from(values)
    return periods.filter((period) => {
        return !!arrayValues.find(([_, i]) => {
            const season = i.text.toLowerCase()
            return !!period[season]
        })
    })
}
